module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": [_vm.id],
      "data-controls-modal": [_vm.id],
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.trackEvent.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-center"
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: [_vm.size ? _vm.size : 'modal-lg']
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "concil-modal-header"
  }, [(_vm.closeFunction && _vm.closable) ? _c('div', [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.trackEvent
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._t("header")], 2), _c('div', {
    class: _vm.bodyClass
  }, [_vm._t("body")], 2), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13215916", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13215916"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/modal/modal.pug
// module id = 1370
// module chunks = 0